import { createContext, useContext, useState, useEffect } from "react";

const ThemeCtx = createContext(null);
export const useTheme = () => useContext(ThemeCtx);

export function ThemeProvider({ children }) {
  const [universe, setUniverseState] = useState(() => localStorage.getItem("lo_universe") || "homme");

  useEffect(() => {
    document.documentElement.dataset.universe = universe;
    localStorage.setItem("lo_universe", universe);
  }, [universe]);

  const setUniverse = (u) => setUniverseState(u === "femme" ? "femme" : "homme");
  return <ThemeCtx.Provider value={{ universe, setUniverse }}>{children}</ThemeCtx.Provider>;
}
